/**
 * The purchase in flight across the checkout redirect: stored in sessionStorage right before
 * the browser leaves for the provider (or, for the fake provider, this app's own success page)
 * and read back on /purchase/success — the same ride-the-redirect pattern the auth flow uses
 * for its pending login.
 */

export interface PendingPurchase {
  readonly tenantId: string;
  readonly accessId: string;
  readonly provider: string;
  readonly sessionId: string;
}

const KEY = 'testMerchant.pendingPurchase';

export function storePendingPurchase(purchase: PendingPurchase): void {
  sessionStorage.setItem(KEY, JSON.stringify(purchase));
}

/** The pending purchase, or null when none is stored or the stored value is not one. */
export function readPendingPurchase(): PendingPurchase | null {
  const raw = sessionStorage.getItem(KEY);
  if (raw === null) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<PendingPurchase>;
    return typeof parsed.tenantId === 'string' &&
      typeof parsed.accessId === 'string' &&
      typeof parsed.provider === 'string' &&
      typeof parsed.sessionId === 'string'
      ? {
          tenantId: parsed.tenantId,
          accessId: parsed.accessId,
          provider: parsed.provider,
          sessionId: parsed.sessionId,
        }
      : null;
  } catch {
    return null;
  }
}

export function clearPendingPurchase(): void {
  sessionStorage.removeItem(KEY);
}
